import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { SoftwarePackageVersion } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useSoftwarePackageVersions } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import {
  SelectSoftwarePackageFormValues,
  SelectSoftwarePackageSummaryDto
} from "../selectSoftwarePackageUtils";
import { SelectSoftwarePackageVersionDropDown } from "./SelectSoftwarePackageVersionDropDown";

export interface SelectSoftwarePackageVersionDropDownHostProps {
  softwarePackage: SelectSoftwarePackageSummaryDto;
  selection?: SelectSoftwarePackageFormValues;
  onUpdateSoftwarePackageVersion: (
    softwarePackageId: string,
    softwarePackageVersionId: string
  ) => void;
}

export const SelectSoftwarePackageVersionDropDownHost = ({
  softwarePackage,
  selection,
  onUpdateSoftwarePackageVersion
}: SelectSoftwarePackageVersionDropDownHostProps) => {
  const softwarePackageVersionsQuery = useSoftwarePackageVersions({
    softwarePackageId: softwarePackage.softwarePackageId
  });

  const noData = <>No versions available.</>;

  return (
    <QueryStateIndicator<SoftwarePackageVersion[]>
      NoDataNode={noData}
      {...softwarePackageVersionsQuery}
    >
      {versions => {
        return (
          <SelectSoftwarePackageVersionDropDown
            softwarePackageVersions={versions}
            onUpdateSoftwarePackageVersion={onUpdateSoftwarePackageVersion}
            selection={selection}
          />
        );
      }}
    </QueryStateIndicator>
  );
};
